export default __webpack_public_path__ + "wrap-green-diagonal-lines.svg";